// Which string a traveller's character is drawn from. The server sends a
// stable `avatarSeed`; the user id is the fallback so the UI works against an
// older API build.
import type { PublicUser } from "./types";

export function avatarSeedOf(user: Pick<PublicUser, "id" | "avatarSeed"> | null | undefined): string {
  if (!user) return "";
  return user.avatarSeed?.trim() || user.id;
}
